const HTTP_STATUS = {
  SERVER_ERRORS: {
    MIN: 500,
    MAX: 599,
  },
}

export default HTTP_STATUS
